import { Link } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function FinalCTASection() {
  return (
    <section className="py-24 bg-gradient-to-br from-yellow-600 to-yellow-700 text-white relative overflow-hidden">
      <div className="absolute inset-0 bg-[url('https://public.readdy.ai/ai/img_res/a01f23ef501d58b8a70720463bcd995e.jpg')] bg-cover bg-center opacity-20"></div>
      
      <div className="relative max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <h2 className="text-4xl md:text-5xl font-bold mb-6">
          Votre site peut être en ligne dans 3 semaines
        </h2>
        <p className="text-xl mb-8 opacity-90 leading-relaxed">
          Un site qui vous ressemble, pensé pour convertir. Pas un template.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a href="/contact" className="inline-flex items-center justify-center whitespace-nowrap cursor-pointer font-medium transition-all duration-300 bg-white text-yellow-700 hover:bg-slate-100 shadow-lg hover:shadow-xl px-8 py-3.5 text-base">
            Démarrer mon projet
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
          <a href="/contact" className="inline-flex items-center justify-center whitespace-nowrap cursor-pointer font-medium transition-all duration-300 border-2 border-white text-white hover:bg-white hover:text-yellow-700 px-8 py-3.5 text-base">
            Voir l'offre détaillée
          </a>
        </div>
      </div>
    </section>
  );
}
